<template>
  <div class="width100 margin-auto">
    <div class="width100 margin-top10">
      <el-button @click="tocostcollection"> 管理研发费用 </el-button>
    </div>
    <div>
      <el-table
        :data="page"
        border
        style="width: 100%"
        class="eltable margin-top20"
      >
        <el-table-column prop="cate.name" label="费用类型"> </el-table-column>
        <el-table-column label="预算（元）" width="250">
          <template slot-scope="scope">
            <el-input
              class="nullinput"
              v-model="scope.row.fee_plan"
              @blur="roleblur(scope.row, $event)"
              :disabled="scope.row.cate.name == '总计' ? true : false"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="已使用（元）" width="250">
          <template slot-scope="scope">
            <div class="feeplan">{{ scope.row.amount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="使用占比（%)" width="250">
          <template slot-scope="scope">
            <div class="feeplan">{{ scope.row.rate }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { entrdfeetotal, entrdfeemodifyplan } from "@/api/Center/Center.api";

export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      centerNum: "",
      page: [],
    };
  },
  components: {},
  methods: {
    tocostcollection() {
      this.$router.push({
        path: "/expenses-money/Cost-collection",
      });
    },
    roleblur(row, $event) {
      entrdfeemodifyplan({
        id: row.id,
        fee_plan: $event.target.value,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          entrdfeetotal({ project_id: this.centerNum }).then((res) => {
            if (res.data.code == 200) {
              let total = {
                fee_plan: 0,
                cate: {
                  name: "总计",
                },
                amount: 0,
              };
              let allcont = [];
              let amoubtcont = [];

              res.data.data.forEach((i) => {
                allcont.push(i.fee_plan);
                amoubtcont.push(i.amount);
                if (i.rate != null) {
                  i.rate = i.rate + "%";
                }
              });
              allcont.forEach((item) => {
                total.fee_plan = total.fee_plan + Number(item);
              });
              amoubtcont.forEach((item) => {
                total.amount = total.amount + Number(item);
              });
              this.page = res.data.data;
              this.page.push(total);
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.centerNum = window.sessionStorage.getItem("centerNums");
    entrdfeetotal({ project_id: this.centerNum }).then((res) => {
      if (res.data.code == 200) {
        let total = {
          fee_plan: 0,
          cate: {
            name: "总计",
          },
          amount: 0,
        };
        let allcont = [];
        let amoubtcont = [];
        res.data.data.forEach((i) => {
          allcont.push(i.fee_plan);
          amoubtcont.push(i.amount);
          if (i.rate != null) {
            i.rate = i.rate + "%";
          }
        });
        allcont.forEach((item) => {
          total.fee_plan = total.fee_plan + Number(item);
        });
        amoubtcont.forEach((item) => {
          total.amount = total.amount + Number(item);
        });
        this.page = res.data.data;
        this.page.push(total);
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.management {
  width: 150px;
  height: 35px;
  line-height: 35px;
  background-color: rgba(58, 126, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  text-align: center;
  border-radius: 5px;
}
.nullinput >>> .el-input__inner {
  border: none;
  /* height: 38px; */
  color: #7b83ea;
  text-align: right;
}
.feeplan {
  text-align: right;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 13px;
  text-align: center;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>